import {get, post, postFile} from "@/axios/requestUtil";
import safeRequestUtils from "@/axios/safeHttp/safeRequestUtils";

export const uploadFile = (param) => {
    return postFile("/tianyi/api/uploadFile",param);
}
export const getKeyId = () => {
    return get("/tianyi/public/crypto/publicKey");
};
export const getSsoH5Path = () => {
    return get("/tianyi/api/getSsoH5Path");
};

export const sendCode = (phone) => {
    return safeRequestUtils.safePost("/tianyi/api/sms/sendCode", {phone: phone})
};
export const login = ({phone, code}) => {
    return safeRequestUtils.safePost("/tianyi/api/appUser/login", {
        phone: phone,
        code: code,
    })
};
